import { useNavigate, useParams } from "react-router-dom"
import PageTitle from "../../components/PageTitle";
import PageContent from "../../components/PageContent";
import { useState } from "react";
import If from "../../components/If";
import Loading from "../../components/Loading";
import useApi from "../../hooks/ApiHook";
import { InputText } from "primereact/inputtext";
import { Checkbox } from 'primereact/checkbox';
import { Button } from "primereact/button";
import useToast from "../../hooks/ToastHook";

export default function() {

    const { id } = useParams();
    const navigate = useNavigate();
    const api = useApi();
    const { showSuccess, showAxiosError } = useToast();
    const [ loading, setLoading ] = useState(true);
    const [ saving, setSaving ] = useState(false);
    const [ unit, setUnit ] = useState({ active: true });
    const isNew = id === 'new';

    useState(() => {
        if (isNew) {
            setLoading(false);
            return;
        }
        setLoading(true);
        api.get('measurement-units/' + id).then(({ data }) => {
            setUnit(data);
        }).finally(() => setLoading(false));
    }, [id]);

    const save = e => {
        setSaving(true);
        const request = isNew ? api.post('measurement-units', unit) : api.put('measurement-units/' + id, unit);
        request.then(() => {
            showSuccess('Salvo com sucesso');
            navigate(-1);
        }).catch(showAxiosError).finally(() => setSaving(false));
        e.preventDefault();
    }

    return (
        <div>
            <PageTitle title={`${isNew ? 'Nova' : 'Edição de'} unidade de medida`}/>
            <PageContent>
                <If condition={loading}>
                    <Loading/>
                </If>
                <If condition={!loading}>
                    <form onSubmit={save}>
                        <div className="formgrid grid">
                            <div className="field col-12 md:col-6 lg:col-4">
                                <label>Símbolo</label>
                                <InputText
                                    value={unit.symbol || ''}
                                    maxLength={5}
                                    onChange={e => setUnit({ ...unit, symbol: e.target.value })}
                                    disabled={!isNew}
                                    className="w-full"/>
                            </div>
                            <div className="field col-12">
                                <label>Descrição</label>
                                <InputText
                                    value={unit.description || ''}
                                    maxLength={50}
                                    onChange={e => setUnit({ ...unit, description: e.target.value })}
                                    className="w-full"/>
                            </div>
                            <div className="field-checkbox col-12">
                                <Checkbox 
                                    checked={unit.active}
                                    onChange={e => setUnit({ ...unit, active: e.checked })}/>
                                <label for="city1">Unidade ativa</label>
                            </div>
                        </div>
                        <div className="mt-2">
                            <Button 
                                className="mr-2" 
                                label="Salvar"
                                loading={saving}/>
                            <Button 
                                label="Cancelar" 
                                outlined
                                type="button"
                                disabled={saving}
                                onClick={() => navigate(-1)}/>
                        </div>
                    </form>
                </If>
            </PageContent>
        </div>
    );
}